import { useState } from "react"

import { wrapArray } from "web/services/helpers"
import { pluralize } from "web/services/inflector"
import CheckBox from "web/components/Form/Controls/CheckBox"
import InternalContactLookup from "web/components/Form/Controls/InternalContactLookup"

import OperatorRadio from "../OperatorRadio"
import { DropDownActionButtons } from "../Buttons"
import MobileHeader from "./MobileHeader"
import { conditionFromFormValue as conditionFromFormValueHelper } from "./helpers"

const CURRENT_OPERATOR_VALUE = "current"

const getOperators = (field) => {
  const currentContactLabel = field.multiple_values
    ? `${field.label.toLowerCase()} includes me`
    : `i am ${field.label.toLowerCase()}`

  return [
    { value: "equal", label: "include" },
    { value: "not_equal", label: "exclude" },
    {
      value: CURRENT_OPERATOR_VALUE,
      label: currentContactLabel,
    },
  ]
}

function getInitialFormState(field, condition) {
  if (condition.operator === "equal" && condition.value?.value === "current") {
    return {
      operator: getOperators(field).find(
        (op) => op.value === CURRENT_OPERATOR_VALUE
      ),
      value: null,
      match_blank: condition.match_blank
        ? { value: condition.match_blank }
        : { value: false },
    }
  }

  const operator = condition.operator
    ? getOperators(field).find((op) => op.value === condition.operator)
    : { value: "equal", label: "equal" }

  const value = wrapArray(condition.value)

  return {
    value,
    match_blank: condition.match_blank
      ? { value: condition.match_blank }
      : { value: false },
    operator,
  }
}

export function conditionFromFormValue(field, formValue) {
  if (formValue.operator?.value === CURRENT_OPERATOR_VALUE) {
    return {
      field_id: field.id,
      operator: "equal",
      value: { value: "current" },
      match_blank: formValue.match_blank
        ? formValue.match_blank.value
        : undefined,
    }
  }
  return conditionFromFormValueHelper(field, formValue)
}

export default function EditDateConditionDropDown({
  field,
  condition,
  onChange = () => {},
  onClear = () => {},
  onCancel = () => {},
}) {
  const [formState, setFormState] = useState(
    getInitialFormState(field, condition)
  )

  const lookupEnabled = formState.operator.value !== CURRENT_OPERATOR_VALUE

  return (
    <div className="flex min-h-full flex-col justify-between p-6 md:min-h-xs md:min-w-lg">
      <MobileHeader field={field} onCancel={onCancel} />
      <div className="flex flex-grow flex-col space-y-5 md:flex-row md:justify-between md:space-x-3 md:space-y-0">
        <div className="md:min-w-4xs">
          <OperatorRadio
            flexDirection="col"
            id="operator"
            name="operator"
            lookup_values={getOperators(field)}
            value={formState.operator}
            onChange={(newOperator) =>
              setFormState((prev) => {
                let value = prev.value
                if (newOperator.value === CURRENT_OPERATOR_VALUE) {
                  value = null
                }

                return {
                  ...prev,
                  value,
                  operator: newOperator,
                }
              })
            }
          />
        </div>
        <div className="md:w-64">
          {lookupEnabled && (
            <InternalContactLookup
              autoFocus={true}
              multiple_values={true}
              id="value"
              name="value"
              value={formState.value}
              onChange={(value) =>
                setFormState((prev) => ({
                  ...prev,
                  value,
                }))
              }
            />
          )}
        </div>
      </div>
      <div className="flex flex-col justify-end space-y-4 text-sm">
        <CheckBox
          inline={true}
          showValueLabel={false}
          label={`Include ${pluralize(
            field.subject_type.toLowerCase()
          )} without ${field.label}`}
          id="match-blanks"
          name="match-blanks"
          value={formState.match_blank}
          onChange={(value) =>
            setFormState((prev) => ({
              ...prev,
              match_blank: value,
            }))
          }
        />
        <DropDownActionButtons
          handleClear={onClear}
          handleAdd={() => onChange(conditionFromFormValue(field, formState))}
        />
      </div>
    </div>
  )
}
